import { images } from '../../constants';
export const data = [
  {
    name: 'Spotify Clone',
    description:
      'A music player web app created using NEXTJS,Supabase,Stripe,Tailwind Css...',
    image: images.spotify_clone,
    percent: '24%',
    link: 'https://spotify-clone-varunnaik.vercel.app/',
  },
  {
    name: 'HireMe Job Portal',
    description:
      'A Job search portal created using ReactJS,contextAPI,Firebase,MaterialUI...',
    image: images.hireme,
    percent: '40%',
    link: 'https://hireme-jobs.netlify.app/',
  },
  {
    name: 'Color-Spotter Game',
    description:
      'A Fun React Game created with 3 level difficulties using ReactJs',

    image: images.color_spotter,
    percent: '55%',
    link: 'https://color-spotter-varunnaik.netlify.app/',
  },
  {
    name: 'Personal Portfolio',
    description:
      'A responsive personal portfolio created using ReactJs and sanityIO,Scss...',

    image: images.portfolio,
    percent: '80%',
    link: 'https://varunnaik-personal-portfolio.netlify.app/',
  },
];
